import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Navbar with fixed z-index to stay on top */}
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>
      
      {/* Main content - add pt-16 or pt-20 depending on navbar height */}
      <main className="flex-1 pt-16">
        {children}
      </main>

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default PublicLayout;